import { useDroppable } from '@dnd-kit/core';

// Stone at rest; the mint is kept for the drag-over state, where it reads as the
// active drop affordance rather than a panel colour.
const wrapperBaseClasses =
    'rounded-lg bg-surface-alt p-4 mb-4 border-2 border-dashed border-transparent transition-colors';
const wrapperOverClasses = 'border-primary bg-primary-surface/80';
const rowClasses = 'flex gap-4';
const bodyClasses = 'w-full';
const labelClasses = 'block mb-2 text-content font-medium';
const inputClasses =
    'w-full h-10 px-3 py-1.5 text-base text-content bg-white ' +
    'border border-border rounded-md transition-colors ' +
    'focus:outline-none focus:ring-2 focus:ring-primary-ring focus:border-primary';

const DroppableNewProvider = ({ dropId, providerName, onChange }) => {
    const { setNodeRef, isOver } = useDroppable({ id: dropId });
    return (
        <div
            ref={setNodeRef}
            className={`${wrapperBaseClasses} ${isOver ? wrapperOverClasses : ''}`}
        >
            <div className={rowClasses}>
                <div className={bodyClasses}>
                    <label className={labelClasses}>
                        {isOver ? 'Drop to create new provider' : 'Add New Provider'}
                    </label>
                    <input
                        type="text"
                        name="new"
                        value={providerName}
                        onChange={(e) => onChange(e.target.value)}
                        placeholder="Enter provider name, then drag a file here"
                        className={inputClasses}
                        onPointerDown={(e) => e.stopPropagation()}
                    />
                </div>
            </div>
        </div>
    );
};

export default DroppableNewProvider;
